import type { CSSProperties } from 'react'
import type { SxProps, Theme } from '@mui/material'

export const headerCellSx: SxProps<Theme> = {
  color: 'text.secondary',
  fontSize: '0.75rem',
  fontWeight: 600,
  textTransform: 'uppercase',
  letterSpacing: '0.05em',
  borderBottomColor: 'divider',
  py: 1,
}

export const cellSx: SxProps<Theme> = {
  color: 'text.secondary',
  fontSize: '0.8rem',
  borderBottomColor: 'divider',
  py: 1,
}

export const rowSx: SxProps<Theme> = {
  '&:last-child td': {
    borderBottom: 0,
  },
}

export const chipSx: SxProps<Theme> = {
  height: 22,
  fontSize: '0.7rem',
}

export const visuallyHiddenStyle: CSSProperties = {
  position: 'absolute',
  width: '1px',
  height: '1px',
  padding: 0,
  margin: '-1px',
  overflow: 'hidden',
  clipPath: 'inset(50%)',
  whiteSpace: 'nowrap',
  borderWidth: 0,
}
